import React from 'react'

export const GridLoader = () => {
    return (
        <div className="k-loading-mask mt-1">
            <div className="k-loading-image" />
            <div className="k-loading-color" />
        </div>
    )
}
